module.exports = __webpack_public_path__ + "img/loader-dark.a80e002d.png";